import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


import {AngularFireModule} from '@angular/fire/compat';

import {
  APP_NAME,
  APP_VERSION,
  DEBUG_MODE as ANALYTICS_DEBUG_MODE,
  COLLECTION_ENABLED
} from '@angular/fire/compat/analytics';

import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {AngularFirestoreModule, SETTINGS as FIRESTORE_SETTINGS} from '@angular/fire/compat/firestore';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireAuthModule, USE_DEVICE_LANGUAGE} from '@angular/fire/compat/auth';
// import {VAPID_KEY} from '@angular/fire/compat/messaging';
import {SETTINGS as REMOTE_CONFIG_SETTINGS, DEFAULTS as REMOTE_CONFIG_DEFAULTS} from '@angular/fire/compat/remote-config';

import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {environment} from '@environments/environment';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    //
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule, // imports firebase/database, only needed for database features
    AngularFireAuthModule,
    AngularFireStorageModule, // storage

    // AngularFirestoreModule.enablePersistence({synchronizeTabs: true}),

    // provide modular style for AppCheck, see app.browser/server
    AngularFireModule,
    //

  ],

  providers: [
    // {provide: FIRESTORE_SETTINGS, useValue: {ignoreUndefinedProperties: true}},
    {provide: ANALYTICS_DEBUG_MODE, useValue: true},
    {provide: COLLECTION_ENABLED, useValue: true},

    {provide: REMOTE_CONFIG_SETTINGS, useFactory: () => isDevMode() ? {minimumFetchIntervalMillis: 10_000} : {}},

    {provide: REMOTE_CONFIG_DEFAULTS, useValue: {background_color: 'red'}},
    {provide: USE_DEVICE_LANGUAGE, useValue: true},

    // {provide: VAPID_KEY, useValue: environment.vapidKey},

    // { provide: SERVICE_WORKER, useFactory: () => typeof navigator !== 'undefined' && navigator.serviceWorker?.register('firebase-messaging-sw.js', { scope: '__' }) || undefined },
    {provide: APP_VERSION, useValue: '0.0.0'},
    {provide: APP_NAME, useValue: 'appClient'},

  ],


})
export class FirebaseStatusModule {
}
